import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { HeroSection } from "@/components/lead-generation-sales/HeroSection";
import { ServicesGrid } from "@/components/lead-generation-sales/ServicesGrid";
import { BenefitsSection } from "@/components/lead-generation-sales/BenefitsSection";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const LeadGenerationSales = () => {
  return (
    <ServiceLayout serviceName="Lead Generation">
      <HeroSection />
      <ServicesGrid />
      <BenefitsSection />
      <ServiceFAQ faqs={serviceFAQs["lead-generation"]} serviceName="Lead Generation" />
      <ServiceCTA serviceName="Lead Generation" />
    </ServiceLayout>
  );
};

export default LeadGenerationSales;